import { styled } from '@material-ui/core';
// import {ReactComponent  as DeleteIcon} from 'assets/icons/ban.svg'

export const MainBody = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'end',
}));

export const Overlay = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, .5)',
  zIndex: 0,
}));
